import { appConfigInitialState } from './AppConfig';
import { checkoutInitialState } from './Checkout';
import { contentCardsInitialState } from './ContentCards';
import { freeFormInitialState } from './FreeForm';
import { integrationsInitialState } from './Integrations';
import { layoutInitialState } from './Layout';
import { purchaseModeInitialState } from './PurchaseMode';
import { plansInitialState } from './Plans';
import { secondScreenInitialState } from './SecondScreen';
import { promoCodeInitialState } from './PromoCode';
import { userInitialState } from './User';
import { trackingInitialState } from './Tracking/initialState';
import { subscriptionsInitialState } from './Subscriptions';
import { paymentsInitialState } from './Payments';
import { paymentMethodsInitialState } from './PaymentMethods';

const initialState = {
  appConfig: appConfigInitialState,
  contentCards: contentCardsInitialState,
  checkout: checkoutInitialState,
  freeForm: freeFormInitialState,
  integrations: integrationsInitialState,
  pageLayout: layoutInitialState,
  secondScreen: secondScreenInitialState,
  purchaseMode: purchaseModeInitialState,
  promoCode: promoCodeInitialState,
  user: userInitialState,
  tracking: trackingInitialState,
  plans: plansInitialState,
  subscription: subscriptionsInitialState,
  payments: paymentsInitialState,
  paymentMethods: paymentMethodsInitialState,
};

export default initialState;
